"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_number_1 = require("./is-number");
var isDecimal = function (num) {
    return is_number_1.default(num) && num % 1 !== 0;
};
exports.default = isDecimal;
//# sourceMappingURL=is-decimal.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-decimal.js
// module id = 1113
// module chunks = 37